import { ref } from 'vue'
import { useGetLanguage } from '@/hooks/useGetLanguage'

// logo 图片
import logo1 from '@/assets/images/influenbase-case-logo-1.png'
import logo2 from '@/assets/images/influenbase-case-logo-2.png'
import logo3 from '@/assets/images/influenbase-case-logo-3.png'
import logo4 from '@/assets/images/influenbase-case-logo-4.png'
import logo5 from '@/assets/images/influenbase-case-logo-5.png'
import logo6 from '@/assets/images/influenbase-case-logo-6.png'
import logo7 from '@/assets/images/influenbase-case-logo-7.png'

// psylos1
import psylos1_1 from '@/assets/images/psylos1/influenbase-WPS鍥剧墖20250911120042.png'
import psylos1_2 from '@/assets/images/psylos1/influenbase-WPS图片20250911120054.png'
import psylos1_3 from '@/assets/images/psylos1/influenbase-WPS图片20250911120102.png'
import psylos1_4 from '@/assets/images/psylos1/influenbase-WPS鍥剧墖20250911120120.png'

// waterh
import waterh1 from '@/assets/images/waterh/influenbase-WPS鍥剧墖20250911120247.png'
import waterh2 from '@/assets/images/waterh/influenbase-WPS鍥剧墖20250911120305.png'
import waterh3 from '@/assets/images/waterh/influenbase-WPS图片20250911120317.png'
import waterh4 from '@/assets/images/waterh/influenbase-WPS图片20250911120327.png'

// lord&berry
import lb1 from '@/assets/images/lord&berry/influenbase-WPS鍥剧墖20250911120511.png'
import lb2 from '@/assets/images/lord&berry/influenbase-WPS鍥剧墖20250911120524.png'
import lb3 from '@/assets/images/lord&berry/influenbase-WPS鍥剧墖20250911120537.png'
import lb4 from '@/assets/images/lord&berry/influenbase-WPS图片20250911120605.png'
import lb5 from '@/assets/images/lord&berry/influenbase-WPS图片20250911120619.png'

// snaplii
import snap1 from '@/assets/images/snaplii/influenbase-WPS鍥剧墖20250911121031.png'
import snap2 from '@/assets/images/snaplii/influenbase-WPS图片20250911121046.png'
import snap3 from '@/assets/images/snaplii/influenbase-WPS图片20250911121053.png'
import snap4 from '@/assets/images/snaplii/influenbase-WPS图片20250911121135.png'
import snap5 from '@/assets/images/snaplii/influenbase-WPS图片20250911121146.png'
import snap6 from '@/assets/images/snaplii/influenbase-20250928-153723.png'
import snap7 from '@/assets/images/snaplii/influenbase-20250928-153730.png'
import snap8 from '@/assets/images/snaplii/influenbase-20250928-153736.png'

// alibaba
import ali1 from '@/assets/images/alibaba/influenbase-WPS鍥剧墖20250911121202.png'
import ali2 from '@/assets/images/alibaba/influenbase-WPS鍥剧墖20250911121359.png'

// revive
import revive3 from '@/assets/images/revive/influenbase-9d603a00-8b9f-4fbf-be69-4b7651246c52.png'
import revive4 from '@/assets/images/revive/influenbase-cec8a82a-ea9e-4b50-9fbb-ae663683fbee.png'

// d-pow
import dpow1 from '@/assets/images/d-pow/influenbase-20250911-121658.png'
import dpow2 from '@/assets/images/d-pow/influenbase-20250911-121707.png'
import dpow3 from '@/assets/images/d-pow/influenbase-20250911-121714.png'
import dpow4 from '@/assets/images/d-pow/influenbase-20250911-121722.png'
import dpow5 from '@/assets/images/d-pow/influenbase-20250911-121731.png'
import dpow6 from '@/assets/images/d-pow/influenbase-20250911-121738.png'

export const usePageCase = () => {
  const { caseText, toolImg, language } = useGetLanguage()

  const caseData = ref([
    {
      logo: logo1,
      brandDesc: caseText.text1,
      background: caseText.text2,
      challenge: caseText.text3,
      textArr1: caseText.text4,
      textArr2: caseText.text5,
      carouselData: [psylos1_1, psylos1_2, psylos1_3, psylos1_4],
    },
    {
      logo: logo2,
      brandDesc: caseText.text6,
      background: caseText.text7,
      challenge: caseText.text8,
      textArr1: caseText.text9,
      textArr2: caseText.text10,
      carouselData: [waterh1, waterh2, waterh3],
    },
    {
      logo: logo3,
      brandDesc: caseText.text11,
      background: caseText.text12,
      challenge: caseText.text13,
      textArr1: caseText.text14,
      textArr2: caseText.text15,
      carouselData: [lb1, lb2, lb3],
    },
    {
      logo: logo4,
      brandDesc: caseText.text16,
      background: caseText.text17,
      challenge: caseText.text18,
      textArr1: caseText.text19,
      textArr2: caseText.text20,
      carouselData:
        language.value === 'zh'
          ? [snap1, snap2, snap3, snap4, snap5]
          : [snap1, snap2, snap6, snap7, snap8],
    },
    {
      logo: logo5,
      brandDesc: caseText.text21,
      background: caseText.text22,
      challenge: caseText.text23,
      textArr1: caseText.text24,
      textArr2: caseText.text25,
      carouselData: [ali1, ali2],
    },
    {
      logo: logo6,
      brandDesc: caseText.text26,
      background: caseText.text27,
      challenge: caseText.text28,
      textArr1: caseText.text29,
      textArr2: caseText.text30,
      carouselData: [revive3, revive4],
    },
    {
      logo: logo7,
      brandDesc: caseText.text31,
      background: caseText.text32,
      challenge: caseText.text33,
      textArr1: caseText.text34,
      textArr2: caseText.text35,
      carouselData: [dpow1, dpow2, dpow3, dpow4, dpow5, dpow6],
    },
  ])

  // 打开弹窗
  const showDialog = ref(false)
  function handleOpen() {
    showDialog.value = true
  }
  return {
    caseData,
    toolImg,
    showDialog,
    handleOpen,
  }
}
